import { render } from "./LiElementProject.vue?vue&type=template&id=abca2b8e"
import script from "./LiElementProject.vue?vue&type=script&lang=js"
export * from "./LiElementProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__